// Utility to suppress ResizeObserver loop limit exceeded error
const suppressResizeObserverLoopError = () => {
  const resizeObserverError = 'ResizeObserver loop completed with undelivered notifications.';
  
  // 更全面的错误处理
  const originalError = window.console.error;
  window.console.error = (...args) => {
    if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
      return;
    }
    originalError.apply(window.console, args);
  };
  
  window.addEventListener('error', (event) => {
    if (event.message && event.message.includes('ResizeObserver')) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
  });
  
  // 处理未捕获的Promise错误
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message && event.reason.message.includes('ResizeObserver')) {
      event.preventDefault();
      return false;
    }
  });
};

export default suppressResizeObserverLoopError; 